export enum ENV {
  DEVELOPMENT = "development",
  PROD = "production",
  TEST = "test",
}

export type ApplicationConfig = {
  API_BASE_URL: string;
  ENV: ENV;
  AUTH0: {
    AUDIENCE: string;
    CLIENT_ID: string;
    DOMAIN: string;
  };
};
